import React from 'react';

interface Props {
  children: React.ReactNode;
  onOutsideClick: (evt: MouseEvent) => void;
  disabled: boolean;
  useCapture: boolean;
}

class OutsideClick extends React.Component<Props> {
  childNode: HTMLDivElement | null = null;

  static defaultProps = {
    disabled: false,

    // `useCapture` is set to true by default so that a `stopPropagation` in the
    // children will not prevent all outside click handlers from firing - maja
    useCapture: false,
    // useCapture: true,
  };

  componentDidMount(): void {
    const { disabled } = this.props;

    if (!disabled) this.addMouseDownEventListener();
  }

  componentWillUnmount(): void {
    this.removeEventListeners();
  }

  // Use mousedown/mouseup to enforce that clicks remain outside the root's
  // descendant tree, even when dragged. This should also get triggered on
  // touch devices.
  onMouseDown = (evt: MouseEvent): void => {
    const { useCapture } = this.props;
    const t = evt.target as HTMLElement;

    if (!this.childNode) {
      this.removeEventListeners();
    }

    const isDescendantOfRoot = this.childNode && this.childNode.contains(t);

    if (!isDescendantOfRoot) {
      document.addEventListener('mouseup', this.onMouseUp, useCapture);
    }
  };

  // Use mousedown/mouseup to enforce that clicks remain outside the root's
  // descendant tree, even when dragged. This should also get triggered on
  // touch devices.
  onMouseUp = (evt: MouseEvent): void => {
    const { onOutsideClick } = this.props;
    const t = evt.target as HTMLElement;

    const isDescendantOfRoot = this.childNode && this.childNode.contains(t);

    if (!isDescendantOfRoot) {
      onOutsideClick(evt);
    }
  };

  setChildNodeRef = (el: string | HTMLDivElement | null): void => {
    if (el && typeof el !== 'string') {
      this.childNode = el;
    }
  };

  addMouseDownEventListener = (): void => {
    const { useCapture } = this.props;
    document.addEventListener('mousedown', this.onMouseDown, useCapture);
  };

  removeEventListeners = (): void => {
    const { useCapture } = this.props;

    document.removeEventListener('mousedown', this.onMouseDown, useCapture);
    document.removeEventListener('mouseup', this.onMouseUp, useCapture);
  };

  render(): React.ReactNode {
    return <div ref={this.setChildNodeRef}>{this.props.children}</div>;
  }
}

export default OutsideClick;
